import { browserName, browserVersion, osName, osVersion, deviceDetect } from "react-device-detect";
import i18n from '../i18n';
import globalConfig from '../config/global/config.json';
import { getCurrentServerTimeStamp } from "./hmac";
import omit from 'lodash/omit';

export const createLogs = async(level, callDetails) => {

	let enableCreateLogs = i18n.exists("configuration:SET_ERROR_INFO_LOGGING") ? i18n.t('configuration:SET_ERROR_INFO_LOGGING') : globalConfig.SET_ERROR_INFO_LOGGING,
	env = `${import.meta.env.VITE_ENVIRONMENT}`,
	vendor = globalConfig.SET_VENDOR,
	crmId = sessionStorage.getItem('id'),
	emailId = sessionStorage.getItem('em'),
	source = sessionStorage.getItem('src'),
	timeStamp = getCurrentServerTimeStamp(""),
	logData,
	deviceDetail;

	if (typeof (window.DD_LOGS) !== "undefined" && enableCreateLogs) {
		logData = {};
		if (level==="1") {
			logData.level = "info";
			logData.code = "DEFAULT_INFO";
			logData.detail = JSON.stringify(callDetails.data);
		} else if (level==="2") {
			logData.level = "error";
			logData.code = callDetails.errorCode;
			logData.detail = i18n.t(`errors#${callDetails.errorCode}`)
		}
				
		logData.requestName = callDetails.requestName;
		logData.requestStatusCode = callDetails.status;
		logData.requestStatus = callDetails.statusText;
		logData.locale = callDetails.locale;
		logData.vendor = vendor === (null || undefined) ? "DEFAULT_GSK" : vendor;				
		logData.environment = env;
		logData.clientId = (window.gaGlobal === (null || undefined)) ? "DEFAULT_GA_ID_NOT_AVAILABLE": window.gaGlobal.vid;
		logData.CRMID = crmId === (null || undefined) ? "DEFAULT_NOTLOGGEDIN" : crmId;
		logData.EID = emailId === (null || undefined) ? "DEFAULT_NOTLOGGEDIN" : emailId;
		logData.viewportSize = window.innerWidth * window.devicePixelRatio + "x" + window.innerHeight * window.devicePixelRatio;
		logData.screenResolution = window.screen.width * window.devicePixelRatio + "x" + window.screen.height * window.devicePixelRatio;
		logData.encoding = document.charset !== (null || undefined) ? document.charset : "";
		logData.browserName = browserName;
		logData.browserVersion = browserVersion;
		logData.OSName = osName;
		logData.OSVersion = osVersion;
		deviceDetail = deviceDetect();
		logData.deviceDetails = deviceDetail === (null || undefined) ? {vendor: "Desktop", model: "desktop", type: "desktop"} : {model:JSON.stringify(deviceDetail)};
		logData.domain = sessionStorage.getItem('errorPath') ? sessionStorage.getItem('errorPath') : window.location.origin;
		logData.pageName = "consent-portal";
		logData.referrer = document.referrer === (null || undefined) ? "" : document.referrer;
		logData.cookieEnabled = window.navigator.cookieEnabled === (null || undefined) ? "" : window.navigator.cookieEnabled;
		logData.time = timeStamp;
		logData.source = source ?? "DEFAULT_GCP";
		logData.appName = "Consent-Portal";
		const logType = logData.level;
		logData = omit(logData, ['browserName', 'browserVersion', 'OSName', 'OSVersion', 'deviceDetails', 'referrer', 'level']);
		window.DD_LOGS.onReady(function () {
			window.DD_LOGS.logger.log(logData.requestName, logData, logType);
		})		
	}
}	